import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAdminAuth } from '../auth/AdminAuthContext';

export default function TopNav() {
  const { pathname } = useLocation();
  const { logout } = useAdminAuth();
  const navigate = useNavigate();
  
  const handleLogout = () => {
    logout();
    navigate('/login');
  };
  
  const link = (to, label, icon) => (
    <Link className={`anav-link ${pathname===to?'is-active':''}`} to={to}>
      <span className="anav-link__icon">{icon}</span>
      {label}
    </Link>
  );
  
  return (
    <header className="anav">
      <div className="anav__brand">
        <span style={{ fontSize: '1.5rem', marginRight: 8 }}>🎓</span>
        Admin Portal
      </div>
      <nav className="anav__links">
        {link('/', '🏠 Home')}
        {link('/programs', '📚 Programs')}
        {link('/questions', '📝 Questions')}
        {link('/result-content', '📄 Results')}
        {link('/sessions', '👥 Sessions')}
        {link('/analytics', '📊 Analytics')}
        {link('/branding', '🎨 Branding')}
        {link('/deploy', '🚀 Deploy')}
      </nav>
      <button 
        className="btn btn--secondary"
        onClick={handleLogout}
        style={{ marginLeft: 'auto' }}
      >
        Logout
      </button>
    </header>
  );
}